var _ellipse, _path, _path2, _ellipse2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCoins = function SvgCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    color: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.5,
    cy: 11,
    rx: 6.5,
    ry: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 15.5c0 1.105-2.91 2-6.5 2s-6.5-.895-6.5-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 11v8.8c0 1.215-2.91 2.2-6.5 2.2S9 21.015 9 19.8V11"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.5,
    cy: 4,
    rx: 6.5,
    ry: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6 11c-1.892-.23-3.63-.825-4-2m4 7c-1.892-.23-3.63-.825-4-2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M6 21c-1.892-.23-3.63-.825-4-2V4m13 2V4"
  })));
};
export default SvgCoins;